import { mapState } from 'vuex';
export default {
  name: 'CustomTableColumnSelect',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndexes: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  watch: {
    items: {
      handler(newItems) {
        this.activeIndexes = newItems.map((item, index) => {
          if (item.show) {
            return index;
          }
        }).filter(item => item !== undefined);
      },
      immediate: true
    },
    activeIndexes() {
      const result = this.items.map((item, index) => {
        return {
          ...item,
          show: this.activeIndexes.includes(index)
        };
      });
      this.$emit('update', result);
    }
  }
};